export default __webpack_public_path__ + "static/media/011-scarf.7d8dd32f.svg";